import { Swiper } from 'swiper';
import { Navigation } from 'swiper/modules';

export default class SliderFinn {
    static initAll() {
        const sliderBaseContainers = document.querySelectorAll('.slider-finn.swiper');
		if (sliderBaseContainers.length === 0) return;

        const config = {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 40,
            navigation: {
                prevEl: '.swiper-button-prev-finn',
                nextEl: '.swiper-button-next-finn',
            },
            autoHeight: true,
			allowTouchMove: true,
			grabCursor: true,
        };

        sliderBaseContainers.forEach(container => {
			new Swiper(container, config);
		});
    }
}
